import { render, staticRenderFns } from "./RiskAreaPersistView.vue?vue&type=template&id=04052ca2"
import script from "./RiskAreaPersistView.vue?vue&type=script&lang=ts"
export * from "./RiskAreaPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports